const COUNTRIES: Record<string, string> = {
  россия: 'Россия',
  'российская федерация': 'Россия',
  рф: 'Россия',
  russia: 'Россия',
  беларусь: 'Беларусь',
  белоруссия: 'Беларусь',
  'республика беларусь': 'Беларусь',
  belarus: 'Беларусь',
  казахстан: 'Казахстан',
  'республика казахстан': 'Казахстан',
  kazakhstan: 'Казахстан',
}

export function isCountryAddressPart(value: string): boolean {
  return Object.hasOwn(COUNTRIES, value.trim().toLowerCase())
}

function localityKey(part: string) {
  return part.replace(/^(?:город\s+|г(?:\.\s*|\s+))/iu, '').toLowerCase().replace(/ё/g, 'е')
}

function isAdministrativePart(part: string) {
  if (isAddressDetail(part)) return false
  return /(?:^|\s)(?:обл\.?|р-н|ао)(?:\s|$)|область|край|республика|округ|район/iu.test(part)
}

function isAddressDetail(part: string) {
  return /^\d/u.test(part)
    || /^(?:ул\.?|улица|пр-?т\.?|проспект|пер\.?|переулок|наб\.?|набережная|ш\.?|шоссе|б-р\.?|бульвар|пл\.?|площадь|дом|корп(?:ус)?\.?|стр(?:оение)?\.?|кв(?:артира)?\.?|склад|терминал|тер(?:ритория)?\.?|кпп|ворота|подъезд|этаж)\s/iu.test(part)
    || /^д\.?\s*\d/iu.test(part)
    || /\s(?:улица|ул\.?|проспект|пр-т|переулок|пер\.?|шоссе|ш\.?|набережная|наб\.?|бульвар|б-р|площадь|пл\.?)(?:\s|$)/iu.test(part)
}

function formatPart(part: string) {
  return part
    .replace(/^(?:город\s+|г(?:\.\s*|\s+))/iu, '')
    .replace(/^(?:улица\s+|ул(?:\.\s*|\s+))/iu, 'ул. ')
    .replace(/^(?:дом|д\.?)\s*(?=\d)/iu, 'д. ')
    .replace(/^(?:корпус|корп\.?)\s*(?=\d)/iu, 'корп. ')
    .replace(/^(?:строение|стр\.?)\s*(?=\d)/iu, 'стр. ')
    .replace(/^(?:квартира|кв\.?)\s*(?=\d)/iu, 'кв. ')
}

/** Presentation only: keep saved addresses and coordinates intact, and never infer a country. */
export function formatAddressForDisplay(address: string): string {
  const parts = address.split(',').map((part) => part.trim().replace(/\s+/g, ' ')).filter(Boolean)
  const countries = parts.filter(isCountryAddressPart)
  const rest = parts.filter((part) => !isCountryAddressPart(part))
  const explicitCity = rest.find((part) => /^(?:город\s+|г(?:\.\s*|\s+))/iu.test(part))
  // Without a city prefix, only treat an address-like comma-separated part as a locality.
  const city = explicitCity ?? (parts.length > 1 ? rest.find((part) => !isAdministrativePart(part) && !isAddressDetail(part)) : undefined)
  const country = countries[0] ? COUNTRIES[countries[0].toLowerCase()] : undefined
  if (!city) return [country, ...rest.map(formatPart)].filter(Boolean).join(', ')

  const other = rest.filter((part) => localityKey(part) !== localityKey(city))
  const administration = other.filter(isAdministrativePart)
  const details = other.filter((part) => !isAdministrativePart(part))
  return [country, ...administration, city, ...details].filter((part): part is string => Boolean(part)).map(formatPart).join(', ')
}
